module.exports = __webpack_public_path__ + "static/media/amyraa_logo.3a3b9008.png";